<div mat-dialog-content class="wrapper">
	<div class="title">
		<h2>סריקות</h2>
	</div>

	<table *ngIf="_likutScan.likutBarcodeScansDisplay$ | async as scans">
		<ng-container *ngIf="anyAddedInfo$ | async as info">
			<thead>
				<tr>
					<th>פריט</th>
					<th>משקל</th>
					<th>שעה</th>
					<th *ngIf="info.tokef">תוקף</th>
					<th *ngIf="info.eitur">איתור</th>
					<th>הסר</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let scan of scans">
					<td>{{ scan.productId }}</td>
					<td>{{ scan.qty | number : '1.0-3' }}</td>
					<td>{{ scan.timestamp | date : 'HH:mm:ss' }}</td>
					<td *ngIf="info.tokef">{{ scan.tokef | date : 'dd/MM/yy' }}</td>
					<td *ngIf="info.eitur">{{ scan.eitur }}</td>
					<td>
						<button mat-icon-button (click)="_likutScan.handleRemoveFromScanHistory(scan.uuid)"><mat-icon color="primary">close</mat-icon></button>
					</td>
				</tr>
			</tbody>
		</ng-container>
	</table>
</div>

<div mat-dialog-actions>
	<button mat-button (click)="onYesClick()" cdkFocusInitial>סגור</button>
</div>
